import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';


@Injectable()
export class CargoService {

  constructor(public http: HttpClient) {
  }

  getCargo(): Observable<any> {
    const url = environment.baseUrl + '/administracao/cargos/';
    return this.http.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/core/cargo.service.ts